import secureLS from 'secure-ls'

const _ls = new secureLS({encodingType:process.env.encodingType, encryptionSecret: process.env.encryptionSecret});

export default _ls

